module.exports = __webpack_public_path__ + "static/media/us-flag-icon-png-24.881ae0a5.png";